import classNames from 'classnames';
import React from 'react';

import ImageLoader from '../ImageLoader';
import styles from './styles.module.scss';

// Default size (40) is set in CSS so the breakpoint can shrink it on mobile
// without an inline width/height that would need !important to override.
// Any caller passing a non-default size opts out of the mobile shrink and
// gets fixed dimensions via an inline style.
const DEFAULT_SIZE = 40;

const Avatar = ({ imageSrc = '', alt = '', nativeClassName = '', borderType = 'white', size = DEFAULT_SIZE }) => {
    const useInlineSize = size !== DEFAULT_SIZE;
    return (
        <div
            className={classNames(
                styles.wrapper,
                { [styles.borderBlue]: borderType === 'blue' },
                { [styles.borderWhite]: borderType === 'white' },
                nativeClassName && nativeClassName
            )}
            style={useInlineSize ? { width: size, height: size } : undefined}
        >
            <ImageLoader src={imageSrc} alt={alt} />
        </div>
    );
};

export default Avatar;
